module.exports = __webpack_public_path__ + "AnnaTheNewtShop.webp?5ee4f4625a706bf1c0b02a09149dfbf0";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/AnnaTheNewtShop.webp
// module id = 49
// module chunks = 0